import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseMaintenanceController } from '../../_base/BaseMaintenanceController';
import { PartnerAssignmentByAddressListMaintenanceDto } from './PartnerAssignmentByAddressListMaintenanceDto';
import { PartnerAssignmentByAddressItemMaintenanceDto } from './PartnerAssignmentByAddressItemMaintenanceDto';


@Injectable()
export class PartnerAssignmentByAddressMaintenanceController extends
    BaseMaintenanceController<PartnerAssignmentByAddressListMaintenanceDto, PartnerAssignmentByAddressItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "partnerassignmentbyaddress");
    }

    public buildUrl(uri: string): string {
        return "system/partner/partnerassignmentbyaddress" + uri;
    }

    public getPermission(): Array<string> {
        return [];
    }
}
